import React from 'react'

import * as styles from './article-wrapper.module.css'

const HeroMiniAdSpace = ({children}) => {
  return (
        <div className={styles.heroMiniAd}>
            <div dangerouslySetInnerHTML={{ __html: `
              <!-- Ezoic - top_of_page_mobile - top_of_page -->
              <div id="ezoic-pub-ad-placeholder-113"> </div>
              <!-- End Ezoic - top_of_page_mobile - top_of_page -->`}}/>
          <div dangerouslySetInnerHTML={{ __html: `
              <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4556132808286686"
                    crossorigin="anonymous"></script>
              <!-- top-mobile -->
              <ins class="adsbygoogle"
                    style="display:block"
                    data-ad-client="ca-pub-4556132808286686"
                    data-ad-slot="2008801846"
                    data-ad-format="auto"
                    data-full-width-responsive="true"></ins>
              <script>
                    (adsbygoogle = window.adsbygoogle || []).push({});
              </script>`}}/>
        </div>
  )
}

export default HeroMiniAdSpace
